<script>
    export default {
        name: "HomeVideo",
    };
</script>

<template functional>
    <div class="home-video">
        <div class="home-video__text">
            Биван&trade;&nbsp;&mdash; лёгкий и&nbsp;компактный лежак, который надувается без
            насоса. Лежите с&nbsp;комфортом где угодно!
        </div>
        <div class="home-video__wrapper">
            <video
                class="home-video__media"
                poster="/static/bivan/assets/home/poster.jpg"
                autoplay=""
                loop=""
                playsinline
            >
                <source
                    src="/static/bivan/assets/home/Bivan-header.mp4"
                    type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'
                />
                <source
                    src="/static/bivan/assets/home/Bivan-header.webm"
                    type='video/webm; codecs="vp8, vorbis"'
                />
            </video>
        </div>
    </div>
</template>

<style lang="scss">
    .home-video {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 400px;
        background: url("/static/bivan/assets/home/poster.jpg") center no-repeat;
        border-radius: var(--border-lg);
        overflow: hidden;
        &::before {
            content: "";
            position: absolute;
            z-index: 2;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
        }
        @include bp($bp-desktop-sm) {
            border-radius: var(--border-xl);
        }
    }

    .home-video__wrapper {
        display: none;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        @include bp($bp-desktop-sm) {
            position: absolute;
            top: -20%;
            bottom: 0;
            left: 0;
            display: block;
            width: 100%;
            max-width: 100%;
            opacity: 1;
            visibility: visible;
        }
    }

    .home-video__media {
        @include center-absolute(0);
        opacity: 0;
        visibility: hidden;
        @include bp($bp-desktop-sm) {
            opacity: 1;
            visibility: visible;
        }
    }

    .home-video__text {
        position: relative;
        z-index: 3;
        max-width: 435px;
        padding: 0 10px;
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        line-height: 32px;
        text-align: center;
        @include bp($bp-desktop-sm) {
            font-size: 24px;
            font-weight: 900;
            line-height: 38px;
        }
    }
</style>
